export default __webpack_public_path__ + "static/media/work-pc.b0c9f0cf.webp";